import { ApiResponse } from '@interfaces/index';
import { useMutation } from '@tanstack/react-query';
import { getToken } from './config';
import { apiUrlConfig } from './configs/apiUrlConfig';
import createApiClient from './configs/httpHandler';
import { createHeaders } from './httpHeaderConfig';

export const thoughtsAndSpeakUpsApiHandler = {
  getThoughtsAndSpeakUps: async (
    payload: Partial<GetThoughtsAndSpeakUpsPayload>,
  ): Promise<ApiResponse<ThoughtsAndSpeakUpsResponseInterface[]>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).post(
      '/get-user-thoughts-and-speak-ups',
      payload,
    ),
};

export const updateThoughtStatus = async (thoughtId = 0) => {
  const headers = createHeaders({ Authorization: `Bearer ${getToken()}` }) as Record<
    string,
    string
  >;

  delete headers['Content-Type'];
  await fetch(`${process.env.REACT_APP_API_URL}/responses/${thoughtId}`, {
    method: 'POST',
    headers: headers as HeadersInit,
  });
};

export const useUpdateThoughtStatus = () =>
  useMutation({
    mutationFn: (thoughtId: number) => updateThoughtStatus(thoughtId),
  });

export interface GetThoughtsAndSpeakUpsPayload {
  archived: boolean | null;
  type: string | null;
}

export interface ThoughtsAndSpeakUpsResponseInterface {
  id: number;
  type: 'thoughts' | 'speakUps';
  questionId: number | null;
  questionLabel: string | null;
  questionnaire: string | null;
  score: number | null;
  message: string;
  shared: boolean;
  latestResponse: {
    id: number;
    response: string;
    createdAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}
